import { Button } from "antd";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const Style = styled.div`
  padding: 8px;
  max-width: 300px;

  h1 {
    font-size: 16px;
    color: #1F2A37;
    margin-bottom: 12px; 
    font-weight: 500;
  }

  p {
    font-size: 14px;
    color: #4D5761;
    margin-bottom: 12px; 
  }

  .actions {
    display: flex;
    padding-left: 30px;
    gap: 8px;

    .ant-btn {
      flex: 1;
    } 
  }
`;

export default function PopoverContent({ onApprove = () => { }, onClose = () => { } }) {
  const { t } = useTranslation();

  return (
    <Style>
      <h1>{t('Notifications')}</h1>
      <p>
        {t('You have been invited to this application by another user, do you want to see it?.')}
      </p>
      <div className="actions">
        <Button onClick={onClose}>
          {t('Skip')}
        </Button>
        <Button type="primary" onClick={onApprove}>
          {t('See Invitation')}
        </Button>
      </div>
    </Style>
  );
}
